<form [formGroup]="categoryForm" (submit)="onSubmit()">
  <div class="bg-info-subtle rounded-3 mb-3">
    <div class="row">
      <div class="col-md-12">
        @if (existingImageUrl()) {
          <div class="p-3 pb-0">
            <div class="position-relative d-inline-block">
              <img
                [src]="existingImageUrl()"
                alt="Category Image"
                class="rounded-2 border"
                style="max-height: 160px; max-width: 100%; object-fit: contain"
              />
              <button
                type="button"
                class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1 p-1 lh-1"
                (click)="existingImageUrl.set(null); categoryForm.patchValue({ imageId: null })"
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>
          </div>
        }
        <file-drop
          [fileAcceptedFormat]="'.png,.jpg,.jpeg'"
          [titleMsg]="'Upload Category Image'"
          [buttonText]="'Drag and Drop or'"
          (onFileDrop)="onImageFileDrop($event)"
        ></file-drop>
        @if (categoryImage()) {
          <div class="d-flex align-items-center gap-2 my-2 px-3 pb-3">
            <i class="bi bi-file-earmark-image fs-18 text-primary"></i>
            <span class="fw-500">{{ categoryImage()?.file?.name }}</span>
            @if (categoryImage()!.progress !== null && categoryImage()!.progress! < 100) {
              <span class="text-muted ms-2 fs-12">{{ categoryImage()!.progress }}%</span>
            } @else if (categoryImage()!.progress === 100) {
              <i class="bi bi-check-circle-fill text-success ms-2"></i>
            }
            <button
              type="button"
              class="btn btn-sm btn-outline-danger ms-auto"
              (click)="categoryImage.set(null); categoryImageDocumentId.set(null)"
            >
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
        } @else {
          <div class="d-flex flex-column d-md-none">
            <h4 class="text-center text-gray-400">or</h4>
            <div class="d-flex justify-content-center mb-3">
              <button type="button" (click)="captureImage.click()" class="btn btn-dark btn-h42">
                <i class="bi bi-camera fs-16"></i> Take Picture
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="row gy-2">
    <div class="col-lg-6">
      <!-- <input-field
      [requiredLabel]="true"
      [label]="'Product List*'"
      formControlName="productListId"
      [type]="'text'"
      [placeholder]="'Enter Full name'">
    </input-field> -->
      <generic-dropdown
        [items]="productList$ | async"
        [label]="'Product List'"
        [allowSearch]="true"
        [clearable]="true"
        [placeholder]="'Select Product List'"
        formControlName="productListId"
        [required]="true"
        [errormessage]="'Product List is required'"
      >
      </generic-dropdown>
    </div>
    <div class="col-lg-6">
      <input-field
        [requiredLabel]="true"
        [label]="'Category Code'"
        formControlName="code"
        [type]="'text'"
        [placeholder]="'Enter Short Code'"
        [errormessage]="'Category Code is required'"
      >
      </input-field>
    </div>
    <div class="col-12">
      <label class="form-label">Description <span class="text-danger">*</span></label>
      <textarea rows="3" class="form-control" placeholder="write notes here..." formControlName="description">
      </textarea>
      @if (categoryForm.get('description')?.invalid && categoryForm.get('description')?.touched) {
        <div class="text-danger">Description is required</div>
      }
    </div>
  </div>
</form>

<input
  #captureImage
  type="file"
  capture="environment"
  accept="image/*"
  (change)="onImageFileChange($event)"
  class="d-none"
/>
